/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerSubmitQueryMutationResponse, AiAgentV2ControllerSubmitQuery400, AiAgentV2ControllerSubmitQuery401, AiAgentV2ControllerSubmitQuery403 } from "../../models/aiAgentV2Controller/AiAgentV2ControllerSubmitQuery";

function getAiAgentV2ControllerSubmitQueryUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/query` as const }  
  return res
}

/**
 * @description Accepts both flat format (AgentRequestDto) and nested format (ChatRequestDto)
 * @summary Submit an ai-agent-v2 query
 * {@link /api/v1/ai-agent-v2/query}
 */
export async function aiAgentV2ControllerSubmitQuery(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AiAgentV2ControllerSubmitQueryMutationResponse, ResponseErrorConfig<AiAgentV2ControllerSubmitQuery400 | AiAgentV2ControllerSubmitQuery401 | AiAgentV2ControllerSubmitQuery403>, unknown>({ method : "POST", url : getAiAgentV2ControllerSubmitQueryUrl().url.toString(), ... requestConfig })  
  return res.data
}